module.exports = __webpack_public_path__ + "img/figure-3.151fd01e.png";